import React from 'react'
import FormHistory from './compoent/FormHistory'

const index = () => {
  return (
    <div>
        <FormHistory/>
    </div>
  )
}

export default index